export function parsePartOf(value: string): { id: string; start: number; end: number } | null {
  const match = value.match(/([^[]+)\[([\d.]+)-([\d.]+)\]/);
  if (!match) return null;
  return {
    id: match[1],
    start: parseFloat(match[2]),
    end: parseFloat(match[3]),
  };
}
